import {AbstractNegotiationStarter} from "@/modules/diplomacy/services/AbstractNegotiationStarter";
import {injectable} from "inversify";
import {Negotiation} from "@/modules/diplomacy/entity";
import {YouthPlayer, YouthPlayerNegotiation} from "@/modules/youth/entity";
import {Team} from "@/modules/team/entity";

@injectable()
export class YouthPlayerNegotiationStarter extends AbstractNegotiationStarter {
  public async canNegotiation(team: Team, target: YouthPlayer): Promise<boolean> {
    await target.load('recruitedBy');

    return !target.recruitedBy && await super.canNegotiation(team, target);
  }

  protected make(target: YouthPlayer): Negotiation {
    const n = new YouthPlayerNegotiation();
    n.target = target;

    return n;
  }
}